export default __webpack_public_path__ + "static/media/12-1_fileexcel.2c41cc8a.svg";